import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import "./index.css";
import App from "./App.tsx";
import { LDProvider } from "launchdarkly-react-client-sdk";

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

if (!isLocalhost) {
  Sentry.init({
    dsn: "https://6648fdeb2c1854df3340e71f68e0531e@o4509764349132800.ingest.us.sentry.io/4509786817560576",
    sendDefaultPii: true,
  });

  posthog.init("phc_vXjuEzDydMS76GK4frD2fJHQoGes8cPsy2AapEeflSK", {
    api_host: "https://us.i.posthog.com",
    person_profiles: "identified_only",
  });
  posthog.register({ app: "quicksilver" });
}

const context = {
  kind: "user",
  key: "anonymous",
  anonymous: true,
};

createRoot(document.getElementById("root")!).render(
  <LDProvider clientSideID="6809639dd2828d08efca4101" context={context}>
    <StrictMode>
      <App />
    </StrictMode>
  </LDProvider>,
);
